<!-- 缺货预警 -->
<template>
	<div class='page_content'>
		<subComponents  ref="showSelectData"></subComponents>
		<div class="page_content_top">
			<div class="page_content_top_line">
				<el-button type="primary" icon="el-icon-refresh"  size="mini" @click="getDataList()" >
					刷新
				</el-button>
			</div>
			<div class="page_content_top_line">
				<el-form :inline="true" class="demo-form-inline" size="mini">
					<el-form-item label="登记人">
						<el-input clearable   @focus="$refs['showSelectData'].openBox('opmList','wolrReger','opmId')" v-model.trim="getRequestData.opmName">
						</el-input>
					</el-form-item>
                    <el-form-item label="开始时间">
                        <el-date-picker size="mini" v-model="getRequestData.start" format="yyyy MM月 dd日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                     <el-form-item label="结束时间">
                        <el-date-picker size="mini" v-model="getRequestData.end" format="yyyy MM月 dd日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
					<el-form-item>
						<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
					</el-form-item>
					
				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table size="mini"  stripe :data="returnData.list"  height="100%" border  style="width: 100%" highlight-current-row>
				<el-table-column prop="bgmName"  label="登记商品" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="cmName"  label="销售客户" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="bgmManufacturer"  label="生产厂家" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="bgmSpecifications"  label="规格" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="bgmPlaceorigin"  label="产地" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="wolrRegnumber"  label="缺货数量">
				</el-table-column>
				<el-table-column prop="wolrRemark"  label="备注" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="wolrRegerName"  label="登记人" show-overflow-tooltip>
				</el-table-column>
			</el-table>
		</div>
		<div class="page_content_bottom">
			<el-pagination
				background
				@size-change="setDataPageSize"
				@current-change="setDataPageNumber"
				:current-page="getRequestData.page"
				:page-sizes="[30,50,100,500]"
				:page-size="30"
				layout="total, sizes, prev, pager, next, jumper"
				:total="returnData.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			
			getRequestData:{
				wolrReger:'',
				opmName:'',
				page:1,
				rows:30,
				start:
                    new Date(new Date().toLocaleDateString()).getTime() -
                    31 * 24 * 3600 * 1000,
                end:
                    new Date(new Date().toLocaleDateString()).getTime() +
                    24 * 60 * 60 * 1000 -
                    1,
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			
			
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		"getRequestData.opmName"(){
			if(this.getRequestData.opmName == ''){
				this.getRequestData.wolrReger = ''
			}
		},
	},
	//方法集合
	methods: {
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
		isShowData(name,value){
			switch(name){
				case 'wolrReger':
					var info = sessionStorage.getItem('selectUserData')
					if(info){
						let infoTwo = JSON.parse(info)
						this.getRequestData.opmName =  infoTwo.opmName
						this.getRequestData.wolrReger =  infoTwo.opmId
					}
					break;
				default:
					this.getRequestData[name] = value
					
				
			}
		
			console.log(name)
			
		},
	
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getShortageRegistration(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
		async getButtonList(){
			this.buttonList = await this.$common.getActionButton()
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getDataList()
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

